import React, { useState } from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../../assets';
import { theme } from '../../../theme';
import { ToggleButton } from '../../button';

export type ToggleProps = {
  initialValue?: string;
  onSelect: (value: string) => void;
  options: ToggleOption[];
  tabIndex?: number;
};

export type ToggleOption = {
  icon?: SvgComponent;
  value: string;
  detail?: string;
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Button = styled(ToggleButton)`
  margin-right: ${theme.spacings[4].rem};
`;

export const Toggle: React.FC<ToggleProps> = ({
  initialValue,
  onSelect,
  options,
  tabIndex,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    options.find((opt) => opt.value === initialValue)?.value
  );

  const handleSelect = (value: string) => {
    onSelect(value);
    setSelectedOption(value);
  };

  return (
    <Wrapper>
      {options.map((opt) => (
        <Button
          {...opt}
          key={opt.value}
          onClick={handleSelect}
          selected={opt.value === selectedOption}
          tabIndex={tabIndex}
        />
      ))}
    </Wrapper>
  );
};
